import React from 'react'
import { IoChevronBack } from "react-icons/io5";
import { Colors } from '../../config';
import { Link } from 'react-router-dom';

const TitleWithBackNavigation = ({ title, link }) => {
    return (
        <div className='w-full flex justify-between items-center flex-wrap  '>
            <p className='font-semibold text-lg'>{title}</p>
            <Link to={link}>
                <div className='w-fit flex items-center gap-2 cursor-pointer'>
                    <div className='rounded-full p-1 bg-white'>
                        <IoChevronBack color={Colors.AppYellow} />
                    </div>
                    <span>Back</span>
                </div>
            </Link>
        </div>
    )
}

export default TitleWithBackNavigation